<template>
	<include-header-main />

	<section id="search_idpw">
		<div class="search_inner">
			<div class="main_tit"><span>덴탈클라우드</span> 아이디/비밀번호 찾기</div>
			<ul class="idpw_tab">
				<li class="id_tab" :class="{active: type === 1 }" @click="setType(1)">아이디 찾기</li>
				<li class="pw_tab" :class="{active: type === 2 }" @click="setType(2)">비밀번호 찾기</li>
			</ul>
			<div class="idpw_box">
				<!-- // 아이디 찾기 -->
				<div class="id_box" v-show="type === 1">
					<div class="name">
						<label for="mb_name">이름</label><br>
						<input type="text" v-model="form.mb_name" id="mb_name" placeholder="이름" required="">
					</div>
					<div class="phone">
						<label for="phone1">휴대전화</label><br>
						<select v-model="form.phone1" id="phone1" class="phone1" required="">
							<option selected="">010</option>
							<option>011</option>
							<option>016</option>
							<option>017</option>
							<option>018</option>
							<option>019</option>
							<option>070</option>
						</select>
						<span class="hyphen">-</span>
						<input type="text" data-type="number" v-model="form.phone2" id="phone2" class="phone2" required="" maxlength="4" @input="handleMaxLengthCheck">
						<span class="hyphen">-</span>
						<input type="text" data-type="number" v-model="form.phone3" id="phone3" class="phone3" required="" maxlength="4" @input="handleMaxLengthCheck">
					</div>
					<small class="text-blue">아이디 전체를 확인하고 싶으신 경우, 관리자에 문의 바랍니다.</small>
					<button type="button" class="id_search_btn btn_style1" v-show="show_id_btn" id="btn_submit" @click.prevent="getId()">아이디 찾기</button>
					<div v-show="!show_id_btn"><small class="text-orange" v-html="show_id_error"></small></div>
				</div>

				<!-- // 비밀번호 찾기 -->
				<div class="id_box" v-show="type === 2">
					<div class="name">
						<label for="mb_id">아이디</label><br>
						<input type="text" v-model="form.mb_id" id="mb_id" placeholder="아이디" required="">
					</div>
					<div class="name">
						<label for="mb_email">이메일</label><br>
						<input type="email" v-model="form.mb_email" id="mb_email" placeholder="example@example.com" required="">
					</div>
					<small class="text-blue">메일이 도착하지 않거나 메일 주소가 변경된 경우 관리자에게 문의해주세요.</small>
					<button type="button" class="pw_search_btn btn_style1" v-show="show_pw_btn" @click.prevent="getPw()">비밀번호 찾기</button>
					<div v-show="!show_pw_btn"><small class="text-orange" v-html="show_pw_error"></small></div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import header_main from '../components/layout/header-main.vue'
import footer from '../components/layout/footer.vue'

export default {
	name: 'App',
	components: {
		'include-header-main': header_main,
		'include-footer': footer
	}
}
</script>

<script setup>
import { env as SERVER_URL } from '@/components/utils/env';
import { onMounted, ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as globaljs from '@/components/utils/global';
import * as commonjs from '@/components/utils/common';
import * as registerjs from '@/components/utils/register';

const route = useRoute();
const router = useRouter();

const type = ref(1);

const setType = (newtype) => {
	type.value = newtype;
}

const form = ref({
	mb_id: '',
	mb_name: '',
	mb_email: '',
	phone1: "010",
	phone2: '',
	phone3: '',
});

// 이벤트 핸들러 함수 정의
function handleMaxLengthCheck(event) {
	maxLengthCheck(event, form); // `form`이 `ref`로 전달됨
}

function handleValueCheck(event) {
	valueCheck(event, form); // `form`이 `ref`로 전달됨
}

// `maxLengthCheck` 함수 정의
function maxLengthCheck(event, dataObjectRef) {
	const object = event.target;

	if (typeof dataObjectRef.value === 'undefined') {
		console.debug('Invalid data object reference provided.');
		return;
	}

	// 나머지 함수 로직...
	const modelName = object.id;
	if (!modelName) {
		console.debug('Input element does not have an id attribute.');
		return;
	}

	// 숫자만 허용하는 경우, 숫자가 아닌 문자 제거
	if (object.dataset.type === 'number') {
		object.value = object.value.replace(/\D/g, '');
	}

	// maxLength 제한이 있는 경우, 입력 길이를 제한
	if (object.maxLength) {
		if (object.value.length > object.maxLength) {
			object.value = object.value.slice(0, object.maxLength);
		}
	}

	// `modelName`이 `dataObjectRef.value`에 있는지 확인
	try {
		if (modelName in dataObjectRef.value) {
			dataObjectRef.value[modelName] = object.value; // 데이터 모델 업데이트
			// console.log(`Updated ${modelName} in data object:`, dataObjectRef.value[modelName]);
		} else {
			console.debug(`Model '${modelName}' not found in data object.`);
		}
	} catch (error) {
		console.error('Error updating data model:', error);
	}
}

function valueCheck(event, dataObjectRef) {
	const object = event.target;

	// 디버깅: 전달된 객체가 무엇인지 콘솔에 출력
	console.log('Received dataObjectRef:', dataObjectRef);

	// `dataObjectRef.value`가 유효한지 확인
	if (typeof dataObjectRef.value === 'undefined') {
		console.debug('Invalid data object reference provided.');
		return;
	}

	// `id` 속성을 사용하여 데이터 모델 속성 이름을 추론
	const modelName = object.id;
	if (!modelName) {
		console.debug('Input element does not have an id attribute.');
		return;
	}

	// 입력 값이 비어 있는 경우 0으로 설정
	let newValue = object.value.trim();
	if (newValue.length < 1) {
		newValue = '0';
	} else {
		// 숫자 변환: 앞의 불필요한 0을 제거
		newValue = parseInt(newValue, 10).toString();
	}

	// DOM 업데이트
	object.value = newValue;

	// Vue 데이터 모델 업데이트
	if (modelName in dataObjectRef.value) {
		dataObjectRef.value[modelName] = newValue;
		// console.log(`Updated ${modelName} in data object:`, dataObjectRef.value[modelName]);
	} else {
		console.debug(`Model '${modelName}' not found in data object.`);
	}
}

const show_id_error = ref('');
const show_id_check1 = ref(false);
const show_id_check2 = ref(false);
const show_id_check3 = ref(false);
const show_id_btn = ref(false);

const show_pw_error = ref('');
const show_pw_check1 = ref(false);
const show_pw_check2 = ref(false);
const show_pw_btn = ref(false);


onMounted(async () => {
	commonjs.DOMLoaded();
	//registerjs.DOMLoaded();
	/*
	let emailRule = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;
let phone2Rule = /^[0-9]{3,4}$/i;
let phone3Rule = /^[0-9]{4}$/i;
	*/
});

watch(
	() => [form.value.phone2, form.value.phone3, form.value.mb_name], ([nVal, nVal2, nVal3], [oVal, oVal2, oVal3]) => {
		show_id_error.value = '';

		if (nVal3 && nVal3.length > 0) {
			show_id_check3.value = true;
		} else {
			show_id_check3.value = false;
			show_id_error.value += ' 이름을 입력해 주세요.<br/>';
		}

		if (nVal && nVal.length >= 3) {
			show_id_check1.value = true;
		} else {
			show_id_check1.value = false;
			show_id_error.value += ' 휴대전화번호 가운데 자리(숫자3~4자리)를 형식에 맞게 입력해 주세요.<br/>';
		}

		if (nVal2 && nVal2.length >= 4) {
			show_id_check2.value = true;
		} else {
			show_id_check2.value = false;
			show_id_error.value += ' 휴대전화번호 끝 자리(숫자4자리)를 형식에 맞게 입력해 주세요.<br/>';
		}

		show_id_btn.value = show_id_check1.value && show_id_check2.value && show_id_check3.value;

	}, {
		immediate: false // 컴포넌트가 마운트될 때 즉시 실행
	}
)

watch(
	() => [form.value.mb_id, form.value.mb_email], ([nVal, nVal2], [oVal, oVal2]) => {
		show_pw_error.value = '';

		if (nVal && nVal.length > 0) {
			if (!registerjs.idRule.test(nVal)) {
				show_pw_error.value += '아이디 형식(영문+숫자 6~20자리)에 맞게 입력해 주세요.<br/>';
			} else {
				console.log('true1');
				show_pw_check1.value = true;
			}
		} else {
			show_pw_check1.value = false;
			show_pw_error.value += ' 아이디를 입력해 주세요.<br/>';
		}

		if (nVal2 && nVal2.length > 0) {
			if (!registerjs.emailRule.test(nVal2)) {
				show_pw_error.value += ' 이메일 형식에 맞게 입력해 주세요.<br/>';
				show_pw_check2.value = false;
			} else {
				console.log('true2');
				show_pw_check2.value = true;
			}
		} else {
			show_pw_check2.value = false;
			show_pw_error.value += ' 이메일을 입력해 주세요.<br/>';
		}

		show_pw_btn.value = show_pw_check1.value && show_pw_check2.value;

	}, {
		immediate: false // 컴포넌트가 마운트될 때 즉시 실행
	}
)

const getId = async () => {
	if (!form.value.mb_name || form.value.mb_name.length < 1) {
		toast.fire({
			icon: "error",
			title: '이름을 입력해주세요.'
		});
		setTimeout(function () { document.querySelector('#mb_name').focus(); }, 100);
		return false;
	}
	if (!registerjs.phone2Rule.test(form.value.phone2)) {
		toast.fire({
			icon: "error",
			title: '휴대전화번호 가운데 자리(숫자3~4자리)를 형식에 맞게 입력해 주세요.'
		});
		setTimeout(function () { document.querySelector('#phone2').focus(); }, 100);
		//commonjs.formSwal('휴대전화번호', '휴대전화번호 가운데 자리(숫자3~4자리)', '#phone2', 'type');
		return false;
	}
	if (!registerjs.phone3Rule.test(form.value.phone3)) {
		toast.fire({
			icon: "error",
			title: '휴대전화번호 끝자리(숫자4자리)를 형식에 맞게 입력해 주세요.'
		});
		setTimeout(function () { document.querySelector('#phone3').focus(); }, 100);
		//commonjs.formSwal('휴대전화번호', '휴대전화번호 끝자리(숫자4자리)', '#phone3', 'type');
		return false;
	}

	const params = new URLSearchParams();
	params.append('mb_name', form.value.mb_name);
	params.append('mb_hp', `${form.value.phone1}-${form.value.phone2}-${form.value.phone3}`);
	// URLSearchParams를 객체로 변환
	const object = {};
	params.forEach((value, key) => {
		if (key.endsWith('[]')) {
			const arrayKey = key.slice(0, -2);
			if (!object[arrayKey]) {
				object[arrayKey] = [];
			}
			object[arrayKey].push(value);
		} else {
			object[key] = value;
		}
	});

	// 결과 확인용 로그 출력
	const jsonString = JSON.stringify(object, null, 2); // 들여쓰기 2칸으로 JSON 문자열화
console.info(jsonString);

	try {
		let response = await axios.get(`${SERVER_URL}/api/app/member/find_id`, { params });
console.debug(response.data.result);
		if (response.data.result?.mb_id) {
			Swal.fire({
				title: '아이디 찾기 성공',
				html: `<div style="word-break: keep-all;">아이디는 <span class="text-blue">${response.data.result?.mb_id.slice(0,4)+"**"}</span>입니다.</div>`,
				icon: 'success',
				confirmButtonText: '확인',
				allowOutsideClick: false,  // 외부 클릭 방지
				allowEscapeKey: false,      // ESC 키 눌러서 닫기 방지
				returnFocus: false,
			});
		} else {
			Swal.fire({
				title: '아이디 찾기 실패',
				html: `<div style="word-break: keep-all;">입력하신 정보에 맞는 아이디를 찾지 못했습니다.<br/>이름과 휴대전화번호를 확인하시고 다시 입력해 주세요.</div>`,
				text: '',
				icon: 'error',
				confirmButtonText: '확인',
				allowOutsideClick: false,  // 외부 클릭 방지
				allowEscapeKey: false,      // ESC 키 눌러서 닫기 방지
				returnFocus: true,
			});
		}
	} catch (error) {
console.error('Error getId:', error);
	}
}

const getPw = async () => {
	if (!form.value.mb_id || form.value.mb_id.length < 1) {
		toast.fire({
			icon: "error",
			title: '아이디를 입력해주세요.'
		});
		setTimeout(function () { document.querySelector('#mb_id').focus(); }, 100);
		return false;
	}
	if (!registerjs.idRule.test(form.value.mb_id)) {
		toast.fire({
			icon: "error",
			title: '아이디 형식(영문+숫자 6~20자리)에 맞게 입력해주세요.'
		});
		setTimeout(function () { document.querySelector('#mb_id').focus(); }, 100);
		return false;
	}
	if (!registerjs.emailRule.test(form.value.mb_email)) {
		toast.fire({
			icon: "error",
			title: '이메일 형식에 맞게 입력해주세요.'
		});
		setTimeout(function () { document.querySelector('#mb_email').focus(); }, 100);
		return false;
	}

	const params = new URLSearchParams();
	params.append('mb_id', form.value.mb_id);
	params.append('mb_email', form.value.mb_email);
	// URLSearchParams를 객체로 변환
	const object = {};
	params.forEach((value, key) => {
		if (key.endsWith('[]')) {
			const arrayKey = key.slice(0, -2);
			if (!object[arrayKey]) {
				object[arrayKey] = [];
			}
			object[arrayKey].push(value);
		} else {
			object[key] = value;
		}
	});

	// 결과 확인용 로그 출력
	const jsonString = JSON.stringify(object, null, 2); // 들여쓰기 2칸으로 JSON 문자열화
console.info(jsonString);

	try {
		let response = await axios.get(`${SERVER_URL}/api/app/member/find_pw`, { params });
console.debug(response.data.result);
		if (response.data.result?.mb_id) {
			// Swal.fire({
			// title: '회원정보 찾음',
			// html: `<div style="word-break: keep-all;">입력하신 이메일로 임시비밀번호를 전송했습니다.</div>`,
			// icon: 'success',
			// confirmButtonText: '확인',
			//	allowOutsideClick: false,  // 외부 클릭 방지
			//	allowEscapeKey: false,      // ESC 키 눌러서 닫기 방지
			// returnFocus: false,
			// });

			if (response.data.result?.mb_name && response.data.result?.new_password && response.data.result?.max_id && !isNaN(response.data.result?.max_id)) {
				await send_temppw_to_email(form.value.mb_email, response.data.result?.mb_name, response.data.result?.new_password, response.data.result?.max_id);
			} else {
				Swal.fire({
					title: '회원정보 확인 오류',
					html: `<div style="word-break: keep-all;">회원정보는 찾았으나, 회원 데이터중 오류가 있습니다.</div>`,
					text: '',
					icon: 'error',
					confirmButtonText: '확인',
					allowOutsideClick: false,  // 외부 클릭 방지
					allowEscapeKey: false,      // ESC 키 눌러서 닫기 방지
				});
			}

		} else {
			if (response.data.result?.common?.errYn === 'Y') {
				Swal.fire({
					title: response.data.result?.common?.errTit,
					html: `<div style="word-break: keep-all;">${response.data.result?.common?.errMsg}</div>`,
					text: '',
					icon: 'error',
					confirmButtonText: '확인',
					allowOutsideClick: false,  // 외부 클릭 방지
					allowEscapeKey: false,      // ESC 키 눌러서 닫기 방지
				});
			} else {
				Swal.fire({
					title: '회원정보 찾지 못함',
					html: `<div style="word-break: keep-all;">입력하신 정보에 맞는 아이디를 찾지 못했습니다.<br/>아이디와 이메일을 확인하시고 다시 입력해 주세요.</div>`,
					text: '',
					icon: 'error',
					confirmButtonText: '확인',
					allowOutsideClick: false,  // 외부 클릭 방지
					allowEscapeKey: false,      // ESC 키 눌러서 닫기 방지
				});
			}
		}
	} catch (error) {
console.error('Error getPw:', error);
	}
}

const send_temppw_to_email = async (email, name, temp_pw, max_id) => {
console.debug('send_temppw_to_email', email, name, temp_pw, max_id);
	const api_url = "/hyphen/mn0109000723"; // 프록시를 사용한 URL
	const api_headers = {
		"Content-Type": "application/json",
		"user-id": "wetreecorp",
		"Hkey": "486c875fb8f848dd"
	};

	const JONMUN = `<table width='823px' cellpadding='0' cellspacing='0' border='0' align='center' style='margin: 0 auto;border-spacing:0;border-collapse:collapse;font-size:12px;'><tbody><tr><td style='padding-top:13px;'><table width='100%' cellpadding='0' cellspacing='0' border='0' style='width:100% !important;'><tbody><tr><td align='left' valign='bottom' style='text-align:left;vertical-align:bottom'><a href='http://192.168.10.18:44/' rel='noopener noreferrer' target='_blank'><img src='http://192.168.10.18:44/img/common/logo.png' alt='덴탈클라우드' border='0' width='' style='font-weight:bold;color:#000;vertical-align:top;width: 218px;height: 36px;'></a></td></tr></tbody></table></td></tr><tr><td style='height:9px;'></td></tr><tr><td><table width='100%' cellpadding='0' cellspacing='0' border='0' style='width:100% !important;'><tbody><tr><td align='center' valign='middle' style='border:5px solid #789E85;text-align:center;vertical-align:middle;padding:33px 0;'><strong style='font-size:29px;letter-spacing:-0.09em;color:#000;'>덴탈클라우드 <strong style='font-size:28px;letter-spacing:-0.09em;color:#238C60;'>임시 비밀번호를</strong> 알려드립니다.</strong></td></tr></tbody></table></td></tr><tr><td style='height:40px;'></td></tr><tr><td style='padding:0 23px'><p style='margin:0;line-height:21px;color:#333;font-size:13px;letter-spacing:-0.02em;'><strong>${name} 회원님</strong><br>안녕하세요!<br>임시 비밀번호를 알려드립니다.</p><p style='margin:0;line-height:21px;color:#333;font-size:13px;letter-spacing:-0.02em;'>임시 비밀번호로 로그인하신 후, 반드시 비밀번호를 변경해 이용하시기 바랍니다.</p></td></tr><tr><td style='height:30px;'></td></tr><tr><td style='padding:0 23px'><div style='background:#fafafa;padding:36px 0 32px;text-align:center'><p style='color:#333;font-size:20px;margin:0 0 22px;'>임시 비밀번호&ensp;<span style='color:#238C60;font-weight:bold'>${temp_pw}</span></p><div style='width:220px;height:46px;display:inline-block;line-height:46px;margin:0 auto;background:#fff;border:1px solid #bfbfbf;border-radius:4px;'><a href='http://192.168.10.18:44' target='_blank' style='display:block;font-size:16px;color:#33383e;text-decoration:none;font-weight:bold;text-align:center;' rel='noopener noreferrer'>덴탈클라우드 바로가기</a></div><div style='width:220px;height:48px;display:inline-block;line-height:48px;margin:0 auto;background:#33383e;border-radius:4px;margin-left:10px;'><a href='http://192.168.10.18:44/mypage' target='_blank' style='display:block;font-size:16px;color:#fff;text-decoration:none;font-weight:bold;text-align:center;' rel='noopener noreferrer'>비밀번호 변경하기</a></div></div></td></tr><tr><td height='24' style='height:24px;'></td></tr><tr><td style='padding:0 23px'><p style='margin:0;font-size:13px;color:#333;line-height:21px;letter-spacing:-0.02em;'>* 임시 비밀번호는 덴탈클라우드 운영자도 알 수 없도록 암호화되어 있습니다.</p><p style='margin:0;font-size:13px;color:#333;line-height:21px;letter-spacing:-0.02em;'>* 비밀번호는 로그인 후 <span style='color:#238C60;font-weight:bold;'>내 정보</span>에서 변경하실 수 있습니다.</p><p style='margin:0;font-size:13px;color:#333;line-height:21px;letter-spacing:-0.02em;'>* 덴탈클라우드는 회원님의 소중한 개인정보가 안전하게 지켜질 수 있도록 최선을 다하겠습니다.</p></td></tr><tr><td style='height:20px;'></td></tr><tr><td style='height: 40px;'></td></tr><tr><td style='background:#f8f9fb;'><table width='100%' cellpadding='0' cellspacing='0' border='0' style='width:100% !important;'><tbody><tr><td style='font-size:9pt;color:#000000;line-height:140%;padding:5px 0 5px 23px;'>본 메일은 발신전용으로 회신되지 않습니다.</td></tr></tbody></table></td></tr><tr><td height='10' style='height: 10px;'></td></tr><tr><td><img src='http://192.168.10.18:44/img/common/mail_footer.png' alt='덴탈클라우드 대표자 : 이동훈 | 사업자번호 : 667-88-02056 | 통신판매업 신고번호 : 2021-부산부산진-1366 주소 : 부산광역시 금정구 금강로321번길 57 ⓒ 2024. 덴탈클라우드 all rights reserved.' style='font-size: 12px; vertical-align: top;'></td></tr></tbody></table>`;
console.debug('send_temppw_to_email().JONMUN', JONMUN);

	const data = {
		AD_FLAG: 'N',
		JONMUN: JONMUN.replace(/'/g, '\"'), // 241023 변환해서 저장
		RECEIVER_ID: '덴탈클라우드 회원',
		RECEIVER_NM: name,
		RECEIVER: email,
		REQ_DEPT_ID: 'hyphen',
		REQ_USER_ID: 'wetreecorp',
		SEQ: `dencl-pw${max_id}`,
		SENDER_NM: '덴탈클라우드',
		SENDER: 'info@wetree.kr',
		SUBJECT: '[덴탈클라우드] 임시 비밀번호를 알려드립니다.',
		TMPL_TYPE: '',
	};
	/*
	const data = {
		AD_FLAG: 'N',
		JONMUN: '<p>이메일</p><em>em</em>',
		RECEIVER_ID: '덴탈클라우드 회원',
		RECEIVER_NM: name,
		RECEIVER: email,
		REQ_DEPT_ID: 'hyphen',
		REQ_USER_ID: 'wetreecorp',
		SEQ: `dencl-pw${max_id}`,
		SENDER_NM: '덴탈클라우드',
		SENDER: 'info@wetree.kr',
		SUBJECT: '[덴탈클라우드] 임시 비밀번호를 알려드립니다.',
		TMPL_TYPE: '',
	};
	*/


	try {
		const response = await axios.post(api_url, data, {
			headers: api_headers
		});
console.debug(response.data); // 임시비밀번호 전송
		if (response.data && response.data.common.errYn === 'N') {
			commonjs.formSwal('임시비밀번호 전송 완료', '입력하신 이메일로 임시비밀번호를 전송했습니다.', 'popup');
		} else {
			commonjs.formSwal('임시비밀번호 전송 오류', '이메일 전송중 오류가 발생했습니다. \n(' + response.data.common.errMsg + ')', '#mb_email', 'self');
		}
	} catch (error) {
//console.error(error?.response?.data);
		commonjs.formSwal('임시비밀번호 전송 요청 오류', '이메일 전송중 요청 중 오류가 발생했습니다.', '#mb_email', 'self');
	}
}
</script>